import { lazy } from 'react'

/**
 * The brand's Files, a screen of neither module.
 *
 * Lazy for the reason the module is: it brings the Agent's providers and
 * stylesheets, and somebody who never opens it never downloads them.
 */
export const BrandFiles = lazy(() => import('@/client/files'))
